import React from "react";
import { Placeholder , Row} from "react-bootstrap";


function PlaceHolderActionable() {
  return (
    <div>
      {Array.from({ length: 10 }).map((_, index) => (
        <Row
          className="py-2 mt-0 border"
          style={{ margin: "0px 3px 0px 7px" }}
          key={index}
        >
          <Placeholder animation="glow" className="d-flex py-2">
            <Placeholder xs={4} bg="primary" className="flex-1 me-5 " />
            <Placeholder xs={4} bg="info" className="flex-1 me-5" />
          </Placeholder>

          <Placeholder
            animation="glow"
            className="d-flex py-2 justify-content-between"
          >
            <Placeholder xs={4} bg="secondary" className="flex-1 me-3" />
            <Placeholder xs={4} bg="primary" className="flex-1 mx-5" />
            <Placeholder xs={2} bg="warning" className="flex-1 " />
          </Placeholder>
        </Row>
      ))}
    </div>
  );
}

export default PlaceHolderActionable;
